"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTargeterService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class ContentTargeterService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.contentUrl = '/rest-api/util/contentTargeter?beanPromo=';
        this.genericContentId = new Array();
    }
    getContentTargeterData(contentId) {
        // if (_.where(this.genericContentId, {id: contentId}).length < 1) {
        return this.get(this.contentUrl + contentId).pipe(operators_1.map((data) => data));
        // }else {
        //    this.genericData = _.where(this.genericContentId, {id: contentId})
        //      return Observable.of(this.genericData[0].content);
        // }
    }
}
exports.ContentTargeterService = ContentTargeterService;
//# sourceMappingURL=contenttargeter.service.js.map